<template>
  <div
    class="
      absolute
      top-0
      left-0
      w-full
      h-full
      bg-black
      z-20
      flex flex-col
      items-center
      justify-center
      p-8
    "
  >
    <audio
      class="opacity-0 absolute"
      src="/audio/absolute_silence.mp3"
      muted
      ref="audioEl"
      autoplay
    ></audio>
    <template v-if="showContent">
      <div
        class="
          flex
          items-center
          text-white text-center
          font-bold
          py-2
          px-6
          my-8
          border-2 border-white
          rounded-full
        "
      >
        Stream has started
      </div>
      <p class="text-white text-center leading-relaxed mb-8">
        Click the button below to join the session
        <br />
      </p>
      <ViceButton icon="LogoutIcon" dark @click="goToStream">Go to stream</ViceButton>
    </template>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';
import ViceButton from '@/Components/Buttons/ViceButton';

export default {
  name: 'ObserverInteractionOverlay',
  setup() {
    const sessionStore = useSessionStore();
    const audioEl = ref();
    const showContent = ref(false);

    // Audio cannot be autoplayed without the user interacting.
    // This overlay tries to autoplay a silent audio file to check
    // if the user has interacted with the browser.

    onMounted(() => {
      audioEl.value
        .play()
        .then(() => {
          sessionStore.observerInteracted = true;
        })
        .catch(() => {
          showContent.value = true;
        });
    });

    const goToStream = () => {
      sessionStore.observerInteracted = true;
    };

    return { goToStream, audioEl, showContent };
  },
  components: {
    ViceButton,
  },
};
</script>
